import React from "react";
import { Entity, Field } from "typegraph";

import { ID } from "common/entities/IEntity";
import EntityMultiTagInput from "common/views/tag/EntityMultiTagInput.view";
import { IPanelProps, Panel } from "core/decorators/Panel";

@Entity({
	many: "contributors"
})
class Contributor {

	@Field()
	public id: ID;

	@Field()
	public name: string;

}

@Panel({
	id: "refine-contributor",
	pageParams: true
})
class RefineContributor extends React.Component<IPanelProps<void>> {

	public render() {

		const { pageParams } = this.props;

		const value = pageParams['contributorIds'] && pageParams['contributorIds'].split(',') || [];

		return (
			<EntityMultiTagInput
				viewKey="refine.contributor"
				value={value}
				onChange={this.onChange}
				entity={Contributor}
				getKey={(c) => c.id}
				getSearchParams={
					(query) => {

						return { query, sort: "name" };
					}
				}
			/>
		);
	}

	private onChange = (ids: ID[]) => {
		this.props.actions.pushPageParam('contributorIds', ids.join(','));
	}
}



// WEBPACK FOOTER //
// ./src/panels/contributor/RefineContributor.panel.tsx